import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {System} from "../api/Models";
import {setSystem} from "../redux/system";
import {selectUser, setUser} from "../redux/auth";
import useApi from "../api/useApi";
import {useAppDispatch, useAppSelector} from "../hooks";

export const useSetHostnameCommand = (): ICommand => {
  const messages = useMessageLogic()
  const api = useApi()
  const user = useAppSelector(selectUser)
  const dispatch = useAppDispatch()

  return {
    secure: true,

    help(): string {
      return '- hostname [VALUE]\t\t\t:: sets the system name';
    },

    async process(msg: string): Promise<void> {
      if (!user) {
        return
      }

      const newSystemName = msg.substring('hostname '.length).trim();

      if (newSystemName !== '') {
        let system: System
        if (!user?.defaultSystemId) {
          //create the system!
          system = await api.systems.addSystem(newSystemName)
          dispatch(setSystem(system))
          dispatch(setUser({
            ...user,
            defaultSystemId: system.id
          }))
        } else {
          //update the system name
          system = await api.systems.updateSystem(user?.defaultSystemId, newSystemName)
        }

        dispatch(setSystem(system))
        messages.addNoticeMessage(`set system name to '${newSystemName}'`)
      }

      return new Promise<void>(() => undefined)
    },

    matches(msg: string): boolean {
      return msg.startsWith('hostname ')
    }
  };
}